import { z } from 'zod';
/** Runtime execution context accompanies the signed assertion on primary callbacks. */
export const AgentCallbackUserContextSchema = z.object({
    proxiedIdentityToken: z.string(),
    executingSessionId: z
        .uuid()
        .transform((value) => value.toLowerCase())
        .nullish(),
});
//# sourceMappingURL=callbackSession.js.map